module.exports = __webpack_public_path__ + "media/images/features/invoice-screenshot-f585194771d3694310c364f681ff256f.png";